import { useEffect } from "react";
import { generatedApi } from "src/store/api/generatedApi";
import { useAppDispatch } from "src/store/store";

export const usePreloadOverrideRecipeModal = ({
  tenantName,
  enabled,
}: {
  tenantName: string;
  enabled: boolean;
}): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const subscriptions = [
      dispatch(
        generatedApi.endpoints.listHeatOverrideRecipes.initiate(
          { tenantName },
          { subscribe: true, forceRefetch: false }
        )
      ),
      dispatch(
        generatedApi.endpoints.listHeatOverrideReasons.initiate(
          { tenantName },
          { subscribe: true, forceRefetch: false }
        )
      ),
    ];
    return () => {
      subscriptions.forEach((subscription) => {
        subscription.unsubscribe();
      });
    };
  }, [dispatch, enabled, tenantName]);
};
